import * as React from 'react';
import { ButtonModifier } from '../../../../infrastructure/helpers';
import DefaultButton, { ButtonProp } from '../../default-button/default-button';
import { createCloseButton, ICloseModalButtonProps } from '../create-close-modal-button';
import { CloseIcon } from '../../icons/icons';

const DefaultCloseModalButtonPresentation = (props: Partial<ButtonProp> & ICloseModalButtonProps) => {
    const propsWithDefaults = {
        modifier: ['cancel', 'fat'] as ButtonModifier[],
        text: 'Cancel',
        ...props,
    };

    return <DefaultButton {...propsWithDefaults} onClick={props.onRequestClose} />;
};
const DefaultCloseModalButton = createCloseButton<Partial<ButtonProp>>(DefaultCloseModalButtonPresentation);

const CrossCloseModalButtonPresentation = (props: ICloseModalButtonProps & React.HTMLAttributes<HTMLSpanElement>) => {
    const iconProps = { ...props };
    delete iconProps.onRequestClose;

    // at some point should be re-skinned to use svg, not linked to Zeplin asset so far.
    return <CloseIcon onClick={props.onRequestClose} { ...iconProps }/>;
};
const CrossCloseModalButton = createCloseButton<React.HTMLAttributes<HTMLSpanElement>>(CrossCloseModalButtonPresentation);

export { DefaultCloseModalButton, CrossCloseModalButton };

